import { useTranslation } from 'react-i18next';
import type { NavKey } from './index';

/** Translates registry titles (sections, routes, hub tabs), which are keys under shell:nav. */
export function useNavTitle(): (key: NavKey) => string {
  const { t } = useTranslation('shell');
  return (key) => t(`nav.${key}`);
}
